export default __webpack_public_path__ + "static/media/ltr_blue_cloud.7ca59722.png";